/** Display / interchange labels aligned with Encoding menu (subset). */
export type DocumentEncoding = "utf-8" | "windows-1252";

export function encodingLabel(enc: DocumentEncoding): string {
  return enc === "utf-8" ? "UTF-8" : "ANSI (Windows-1252)";
}
